module.exports = __webpack_public_path__ + "img/img-info-img-s3.ff7223a3.jpg";